import Button from "src/components/elements/Button/Button";
import styles from "src/components/layout/Dialog/dialog.module.css";
import baseStyles from "src/global.module.css";

type DialogProps = {
    isOpen: boolean;
    handleClose: () => void;
    title?: string;
    content?: React.ReactNode;
    onYes?: {
        onClick: () => void;
        label: string;
    };
    onNo?: {
        onClick: () => void;
        label: string;
    };
};

const Dialog: React.FC<DialogProps> = (props) => {
    if (!props.isOpen) return null;

    return (
        <>
            <div
                className={styles.container}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                role="none"
            >
                {props.title && (
                    <>
                        <h2 className={styles.title}>{props.title}</h2>
                        <div className={baseStyles.mb16} />
                    </>
                )}
                {props.content && (
                    <>
                        {props.content}
                        <div className={baseStyles.mb16} />
                    </>
                )}
                {props.onYes && (
                    <>
                        <div className={styles.button_container}>
                            <Button
                                label={props.onYes.label}
                                colors="primary"
                                type="button"
                                widthInfinity
                                onClick={props.onYes.onClick}
                            />
                        </div>
                        {props.onNo && <div className={baseStyles.mb16} />}
                    </>
                )}
                {props.onNo && (
                    <div className={styles.button_container}>
                        <Button
                            label={props.onNo.label}
                            colors="secondary"
                            type="button"
                            widthInfinity
                            onClick={props.onNo.onClick}
                        />
                    </div>
                )}
            </div>
            <div
                className={styles.back_drop}
                onClick={props.handleClose}
                onKeyDown={props.handleClose}
                role="button"
                aria-label="backdrop"
                tabIndex={0}
            />
        </>
    );
};

export default Dialog;
